<template>
  <div class="inscription" data-model-id="3:4599">
    <div class="inscription-container">
      <div class="inscription-left">
        <div class="inscription-content">
          <div class="logo-section">
            <img
              class="logo"
              alt="Florisuite Logo"
              src="https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
            />
          </div>

          <div class="form-section">
            <div class="form-header">
              <h1 class="form-title">Créer un compte</h1>
              <p class="form-subtitle">Commencez votre essai gratuit de 14 jours</p>
            </div>

            <form class="signup-form" @submit.prevent="handleSignup">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" for="firstName">Prénom</label>
                  <input
                    class="form-input"
                    type="text"
                    id="firstName"
                    placeholder="Votre prénom"
                    required
                  />
                </div>

                <div class="form-group">
                  <label class="form-label" for="lastName">Nom</label>
                  <input
                    class="form-input"
                    type="text"
                    id="lastName"
                    placeholder="Votre nom"
                    required
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="form-label" for="email">Email</label>
                <input
                  class="form-input"
                  type="email"
                  id="email"
                  placeholder="votre.email@exemple.com"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label" for="shopName">Nom de la boutique</label>
                <input
                  class="form-input"
                  type="text"
                  id="shopName"
                  placeholder="Le nom de votre boutique"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label" for="password">Mot de passe</label>
                <input
                  class="form-input"
                  type="password"
                  id="password"
                  placeholder="••••••••"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label" for="confirmPassword">Confirmer le mot de passe</label>
                <input
                  class="form-input"
                  type="password"
                  id="confirmPassword"
                  placeholder="••••••••"
                  required
                />
              </div>

              <label class="checkbox-label">
                <input type="checkbox" class="checkbox-input" required />
                <span>
                  J'accepte les <a href="#" class="terms-link">conditions d'utilisation</a> et la
                  <a href="#" class="terms-link">politique de confidentialité</a>
                </span>
              </label>

              <button class="submit-button" type="submit">
                <span class="button-text">Créer mon compte</span>
              </button>
            </form>

            <div class="login-prompt">
              <span class="prompt-text">Vous avez déjà un compte ?</span>
              <RouterLink to="/connexion" class="login-link">
                Se connecter
              </RouterLink>
            </div>
          </div>
        </div>
      </div>

      <div class="inscription-right">
        <div class="hero-content">
          <h2 class="hero-title">Rejoignez des centaines de fleuristes</h2>
          <p class="hero-description">
            Simplifiez la gestion de votre boutique et développez votre activité avec Florisuite.
          </p>
          <img
            class="hero-image"
            alt="Aperçu Florisuite"
            :src="`${publicBase}assets/fonctionnalites/essai.webp`"
          />
          <div class="features-list">
            <div class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>14 jours d'essai gratuit</span>
            </div>
            <div class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Aucune carte bancaire requise</span>
            </div>
            <div class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Support dédié inclus</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "Inscription",
  components: {
    RouterLink,
  },
  data() {
    return {
      publicBase: process.env.BASE_URL || "/",
    };
  },
  methods: {
    handleSignup() {
      alert("Création de compte en cours... (Démo uniquement)");
    },
  },
});
</script>

<style>
.inscription {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

.inscription .inscription-container {
  align-items: stretch;
  display: flex;
  min-height: 100vh;
  max-width: 1440px;
  width: 100%;
}

.inscription .inscription-left {
  align-items: center;
  background-color: #ffffff;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 60px 40px;
}

.inscription .inscription-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 480px;
  width: 100%;
}

.inscription .logo-section {
  align-self: flex-start;
}

.inscription .logo {
  height: 40px;
  width: auto;
}

.inscription .form-section {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

.inscription .form-header {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.inscription .form-title {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
}

.inscription .form-subtitle {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
}

.inscription .signup-form {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.inscription .form-row {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  gap: 16px;
  width: 100%;
}

.inscription .form-group {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.inscription .form-label {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}

.inscription .form-input {
  align-self: stretch;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-sizing: border-box;
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  padding: 12px 16px;
  transition: border-color 0.2s ease;
  width: 100%;
}

.inscription .form-input:focus {
  border-color: #084734;
  outline: none;
}

.inscription .form-input::placeholder {
  color: #9ca3af;
}

.inscription .checkbox-label {
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  gap: 8px;
}

.inscription .checkbox-input {
  cursor: pointer;
  flex-shrink: 0;
  height: 16px;
  margin-top: 2px;
  width: 16px;
}

.inscription .checkbox-label span {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
}

.inscription .terms-link {
  color: #084734;
  font-weight: 600;
  text-decoration: none;
}

.inscription .terms-link:hover {
  text-decoration: underline;
}

.inscription .submit-button {
  all: unset;
  align-self: stretch;
  background-color: #084734;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;
  overflow: hidden;
  padding: 12px 32px;
  position: relative;
  text-align: center;
  transition: all 0.2s ease;
}

.inscription .submit-button:hover {
  background-color: #0a5a42;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.inscription .button-text {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.inscription .login-prompt {
  align-items: center;
  align-self: stretch;
  display: flex;
  gap: 8px;
  justify-content: center;
}

.inscription .prompt-text {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
}

.inscription .login-link {
  color: #084734;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;
}

.inscription .login-link:hover {
  text-decoration: underline;
}

.inscription .inscription-right {
  align-items: center;
  background: linear-gradient(135deg, #084734 0%, #0a5a42 100%);
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 60px 40px;
}

.inscription .hero-content {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 500px;
  width: 100%;
}

.inscription .hero-title {
  align-self: stretch;
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 45px;
}

.inscription .hero-description {
  align-self: stretch;
  color: #d2f1ba;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
}

.inscription .hero-image {
  align-self: stretch;
  border-radius: 12px;
  box-shadow: 0px 10px 28px rgba(0, 0, 0, 0.24);
  max-height: 260px;
  object-fit: cover;
  width: 100%;
}

.inscription .features-list {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.inscription .feature-item {
  align-items: center;
  display: flex;
  gap: 12px;
}

.inscription .check-icon {
  height: 20px;
  width: 20px;
}

.inscription .feature-item span {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
}

@media (max-width: 1024px) {
  .inscription .inscription-container {
    flex-direction: column;
  }

  .inscription .inscription-right {
    display: none;
  }

  .inscription .form-row {
    flex-direction: column;
  }
}
</style>
